// DignifiedPersonalCareSection.js
import React from 'react';
import { Phone } from 'lucide-react';
import dignifiedPersonalCareImage from '../assets/dignified-personal-care-image.jpg';

const DignifiedPersonalCareSection = () => {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

        {/* Left Content */}
        <div>
          <p className="text-primary text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
            Personal Care
          </p>
          <h2 className="font-display font-light text-ink leading-[1.1] text-3xl md:text-4xl lg:text-5xl mb-6">
            Dignified In-Home Personal Care for Seniors in Queensland
          </h2>

          <div className="space-y-4 text-muted text-base leading-relaxed mb-10 max-w-lg">
            <p>
              Most of us wake up and start out our days using the bathroom, bathing, dressing and grabbing a bite to eat. For many seniors this{' '}
              <span className="text-primary font-medium">daily routine</span> is not so easy as they struggle to carry out some of these basic personal care activities. When it happens to your ageing family member, you want them to remain at home while enjoying the independence and dignity they deserve. Having a conversation with a senior loved one, especially a parent, about personal care can be sensitive, and feelings oftentimes get hurt.
            </p>

            <p>
              To make this easier, Wei Care offers reliable, discreet personal care for seniors, delivered by our qualified home care workers. Many families choose our in-home personal care for their loved ones. We have found that, with a caring professional from outside the family, older people are often more comfortable accepting the personal care they deserve.
            </p>
          </div>

          <a
            href="tel:+61480804640"
            className="inline-flex items-center gap-2 bg-primary hover:bg-primary-dark text-white font-medium text-sm px-7 py-3.5 rounded-full transition-colors"
          >
            <Phone size={18} />
            Call +61 420 162 243
          </a>
        </div>

        {/* Right Image */}
        <div className="relative">
          <img
            src={dignifiedPersonalCareImage}
            alt="A carer supporting an older woman outdoors"
            className="w-full h-[420px] lg:h-[560px] object-cover rounded-2xl"
          />
        </div>
      </div>
    </section>
  );
};

export default DignifiedPersonalCareSection;
